import { style } from 'typestyle';
import { primaryTextColor, mediumGutterWidth, smallGutterWidth } from 'src/utils/Style/Theme';
import { important } from 'csx';

const sidenavContainer = style({
  $debugName: 'sidenavContainer',
  display: 'inline-block',
});

const viewContainerPrintable = style({
  $debugName: 'viewContainerPrintable',
  color: primaryTextColor,
  overflowX: 'visible',
  overflowY: 'visible',
  width: '100%',
  height: '100%',
});

const viewContainer = style({
  $debugName: 'viewContainer',
  color: primaryTextColor,
  // allows for view overlays to be bound within the container boundary
  position: 'relative',
  // container grows horizontally as needed
  flexGrow: 1,
  minHeight: 1,
  width: '100%',
  padding: `0px ${smallGutterWidth}px 0px ${mediumGutterWidth}px`,
});

const contentContainer = style({
  $debugName: 'contentContainer',
  // allows for the RightContainer to be bound within the container boundary
  position: 'relative',
  display: 'flex',
  flexGrow: 1,
  minHeight: 1,
});

const appContainer = style({
  $debugName: 'appContainer',
  height: '100vh',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  $nest: {
    '&.print': {
      height: 'auto',
      display: 'inline-block',
    },
  },
});

const footerContainer = style({
  display: 'flex',
  justifyContent: 'right',
  height: '10px',
  width: '100%',
  background: '#f4f3f4',
  $nest: {
    '&.footer-with-icons': {
      height: '30px',
      paddingRight: '0.5rem',
    },
  },
});

const footerInsightsContainer = style({
  minHeight: important('40%'),
  maxHeight: important('60%'),
});

const footerInsightsIcon = style({
  // no styles for now
});

export default {
  appContainer,
  contentContainer,
  footerContainer,
  footerInsightsContainer,
  footerInsightsIcon,
  sidenavContainer,
  viewContainerPrintable,
  viewContainer,
};
